import { useEffect, useState } from 'react';
import { Button } from '@vds/components';

import { getClientLOB } from '@/utils/server/lob-utils';

import styles from './SwitchTool.module.css';

export default function LineOfBusinessSwitch() {
    const [lob, setLob] = useState<string>(getClientLOB());

    useEffect(() => {
        setLob(getClientLOB());
    }, []);

    const getLobColorClass = (lob: string) => {
        if (lob === 'pplus') return styles.colorPplus;
        if (lob === 'ptv') return styles.colorPtv;
        return '';
    };

    const handleLobChange = (newLob: string) => {
        setLob(newLob);

        // Modify hostname based on LOB
        const url = new URL(window.location.href);
        if (newLob === 'pplus') {
            url.hostname = url.hostname.replace('pluto.tv', 'paramountplus.com');
            url.hostname = url.hostname.replace('ptv-appshell', 'appshell');
            if (url.port === '3010') {
                url.port = '3000';
            }
        } else if (newLob === 'ptv') {
            url.hostname = url.hostname.replace('paramountplus.com', 'pluto.tv');
            url.hostname = url.hostname.replace('appshell', 'ptv-appshell');
            if (url.port === '3000') {
                url.port = '3010';
            }
        }
        window.location.href = url.toString();
    };

    return (
        <div className={styles.infoContainer}>
            <h3>Line of Business Switch Tool</h3>
            <div>
                <b>LOB: </b>
                <span className={[styles.valueWrapper, getLobColorClass(lob)].join(' ')}>
                    {lob}
                </span>
            </div>
            <div className={styles.buttonContainer}>
                <Button
                    colorScheme="primary"
                    disabled={lob === 'pplus'}
                    onClick={() => handleLobChange('pplus')}>
                    Paramount+
                </Button>
                <Button
                    colorScheme="primary"
                    disabled={lob === 'ptv'}
                    onClick={() => handleLobChange('ptv')}>
                    PlutoTV
                </Button>
            </div>
        </div>
    );
}
